export default __webpack_public_path__ + "static/media/q28_step4.bb229dbb.png";